@if (request(); as request) {
  <mbp-select-item-modal data-testid="company-selection-modal" [loader]="loadCompanies" [action]="selectCompany"
    [initialSelectedId]="request.initialSelectedId" (close)="onClose()" [labels]="{
      modalTitle: 'doors.companySelectModal.title' | translate,
      saveButtonText: 'doors.companySelectModal.confirm' | translate,
      saveErrorMessage: 'doors.companySelectModal.error' | translate,
      loadErrorMessage: 'doors.companySelectModal.loadError' | translate,
      searchPlaceholder: 'doors.companySelectModal.searchPlaceholder' | translate,
      noDataMessage: 'doors.companySelectModal.noData' | translate,
      loadingMessage: 'doors.companySelectModal.loadingMessage' | translate
    }" />
}
